export default {"src":"/_next/static/media/logoDark.a6c53fff.svg","height":30,"width":123};